/*
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */
var VzcSpinnerSize;
(function (VzcSpinnerSize) {
    VzcSpinnerSize[VzcSpinnerSize["small"] = 28] = "small";
    VzcSpinnerSize[VzcSpinnerSize["medium"] = 42] = "medium";
    VzcSpinnerSize[VzcSpinnerSize["large"] = 80] = "large";
})(VzcSpinnerSize || (VzcSpinnerSize = {}));

/*
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VzcSpinnerSize };
